export enum ExpiredErrorTypes {
    Login = "login",
    EmailVerification = "emailVerification",
}
